import { t } from "i18next"
import * as yup from "yup"
const getShareLeadSupportValidationSchema = () =>
  yup.object().shape({
    sharingType: yup.string(),
    user: yup.string().required(t("User is required")).nullable(),
    sharingPurpose: yup.string().required(t("Purpose is required")).nullable(),
  })

export default getShareLeadSupportValidationSchema
